import React from 'react';
import PropTypes from 'prop-types';
import REDUCER_KEY from 'reducers/reducer.keys';
import { Transfer } from 'components/Page';
import config from './config';

const ActivityCompetencies = ({ objectId, permissions }) => {
  // if record is localy managed and the user has permissions
  const canAdmin = permissions.CanAdminCompetencies()
    .hasPermissions();
  return (
    <Transfer
      canAdmin={canAdmin}
      reducer={{
        destination: REDUCER_KEY.assignedActivityCompetencies,
        source: REDUCER_KEY.unAssignedActivityCompetencies
      }}
      objectId={objectId} // the parent object
      config={{
        ...config,
        // Table ToolBar Buttons
        commands: {
          disableAdd: !canAdmin,
          disableRemove: !canAdmin
        },
        // override source table config with current data
        source: {
          ...config.source,
          // record filter for unassigned users
          filters: {
            activity_id__ne: [objectId]
          },
          // Table row config
          rowSelectionConfig: {
            ...config.source.rowSelectionConfig,
            selectItemOnSingleClick: false,
            highlightRow: canAdmin
          }
        },
        // override destination table config with current data
        destination: {
          ...config.destination,
          // record filter for assigned users
          filters: {
            activity_id: [objectId]
          }
        }
      }}
      permissions={permissions}
    />
  );
};

ActivityCompetencies.propTypes = {
  objectId: PropTypes.number,
  permissions: PropTypes.object.isRequired
};

ActivityCompetencies.defaultProps = {
  objectId: null
};

export default ActivityCompetencies;
